import { FontWeight, Heading } from '@lili/lili-frontend-common';

interface IBoxProps {
  headline: string;
  contentMap: string[];
}

export const Box = ({ contentMap = [], headline }: IBoxProps) => {
  return (
    <div
      id={'required-document__instructions'}
      className='border border-outline-primary-bw-03 w-full bg-surface-primary-bw-00 rounded-[8px] p-[16px] mb-[32px]'>
      <Heading.H9 fontWeight={FontWeight.SEMIBOLD}>{headline}</Heading.H9>
      {Array.isArray(contentMap) &&
        contentMap.map((content, index) => (
          <div key={index} className='gap-[4px] w-[340px]'>
            <Heading.H9>{`${index + 1}. ${content}`}</Heading.H9>
          </div>
        ))}
    </div>
  );
};
